import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Popover, Tooltip } from '@vd/ui';
import { useTours } from './TourProvider';
import { ToursList } from './TourLaunch';
import { DOCK_ATTRIBUTE } from './dock';
import styles from './GetStartedDock.module.css';

/**
 * Get started, at the top of every page (TOADO-981): the tours, each to
 * start, resume or replay, and the way to the setup steps. A tour or its
 * offer shrinks into this button as it goes, so this is where the person
 * looks for them again. Nothing at all where tours are off.
 */
export function GetStartedDock({ className }: { className?: string }) {
  const tours = useTours();
  const [open, setOpen] = useState(false);
  const button = useRef<HTMLButtonElement>(null);
  // A tour started from the list takes over: the list closes behind it.
  const running = tours.active !== null;
  useEffect(() => {
    if (running) setOpen(false);
  }, [running]);
  if (!tours.enabled) return null;
  return (
    <>
      <Tooltip content="Get started" placement="bottom">
        <button
          ref={button}
          type="button"
          className={className}
          aria-label="Get started: tours and setup"
          aria-haspopup="dialog"
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
          {...{ [DOCK_ATTRIBUTE]: '' }}
        >
          <Compass size={16} aria-hidden />
        </button>
      </Tooltip>
      <Popover
        open={open}
        onClose={() => setOpen(false)}
        anchor={button.current?.getBoundingClientRect() ?? null}
        placement="bottom-end"
        width={300}
      >
        <div className={styles.panel} role="dialog" aria-label="Get started" data-testid="get-started-panel">
          <ToursList />
          <Link className={styles.setup} to="/" onClick={() => setOpen(false)}>Setup steps on Home</Link>
        </div>
      </Popover>
    </>
  );
}
